import './visitorTemporaryBadge.css';

import React from 'react';

import { VisitorData } from '../../api/types';
import { UserDetails } from '../UserDetails/UserDetails';

interface VisitorTemporaryBadgeProps {
    userData: VisitorData;
}

export const VisitorTemporaryBadge: React.FC<VisitorTemporaryBadgeProps> = ({ userData }) => (
    <UserDetails firstName={userData.firstName} lastName={userData.lastName} visitor={true} />
);
